import PlusWelcome from './PlusWelcome';

export default PlusWelcome;
